import { MotivoDTO, MotivoProducto } from "../interfaces/MotivoDTO";
import { ObjetoLabel, ObjetoLabelFilter } from "../interfaces/ObjetoLabel";
import axios, { AxiosResponse } from "axios";
import { Categoria, GuardarCategoria, ProductoEsperado } from "../interfaces/Sistema";
import { ResponceApi } from "../interfaces/Responses";
import { CatagNumberDTO } from "../interfaces/CatalogoDTO";
import { Option } from '../interfaces/ProyectosDTOS/Option';
import { IndexacionDTO } from "../interfaces/IndexacionDTO";
const localBack : string = process.env.REACT_APP_BACK || ''; 
const APICATALOGO : string = '/api/Catalogo';

export const RolColaboradorProducto: 
Array<ObjetoLabelFilter> = [
    {
        id: 1,
        label:'AUTOR',
        visibilidad: 'S'
    },
    {
        id: 2,
        label:'CO-AUTOR',
        visibilidad: 'S'
    },
    {
        id: 3,
        label:'EDITOR',
        visibilidad: 'LCL'
    },
    {
        id: 4,
        label:'RELATOR',
        visibilidad: 'N'
    },
    {
        id: 5,
        label:'COMPILADOR',
        visibilidad: 'LCL'
    },
    {
        id: 6,
        label:'INVENTOR',
        visibilidad: 'INV'
    },
    {
        id: 7,
        label:'TUTOR',
        visibilidad: 'T'
    },
    {
        id: 8,
        label:'INSTRUCTOR',
        visibilidad: 'I'
    },
    {
        id: 9,
        label:'ASISTENTE',
        visibilidad: 'A'
    },
    {
        id: 10,
        label:'EVALUADOR',
        visibilidad: 'E'
    },
    {
        id: 11,
        label:'USUARIO',
        visibilidad: 'U'
    },
    {
        id: 12,
        label:'CLIENTE',
        visibilidad: 'C'
    },
    {
        id: 13,
        label:'REVISOR',
        visibilidad: 'LCL'
    }
];

export const UsuarioPro: 
Array<string> = ['edelgado@espol.edu.ec','dade@espol.edu.ec','mbaez@espol.edu.ec','cvaca@espol.edu.ec','ypino@espol.edu.ec','pcrow@espol.edu.ec','fmalo@espol.edu.ec','nmunoz@espol.edu.ec','aboero@espol.edu.ec','dtagle@espol.edu.ec','vtapia@espol.edu.ec','pvaldi@espol.edu.ec','mlnath@espol.edu.ec','hapolo@espol.edu.ec','avaras@espol.edu.ec','hplaza@espol.edu.ec','jperal@espol.edu.ec','gcuzco@espol.edu.ec','jcedeno@espol.edu.ec','mflopez@espol.edu.ec','eaterac@espol.edu.ec','jnietow@espol.edu.ec','aramire@espol.edu.ec','aalvare@espol.edu.ec','psantos@espol.edu.ec','hxmoran@espol.edu.ec','fjacome@espol.edu.ec','dtinoco@espol.edu.ec','imartin@espol.edu.ec','vguzman@espol.edu.ec','fbertuc@espol.edu.ec','eialava@espol.edu.ec','ldender@espol.edu.ec','ogarces@espol.edu.ec','acollag@espol.edu.ec','sguarta@espol.edu.ec','ocoloma@espol.edu.ec','mmendoza@espol.edu.ec','gbaqueri@espol.edu.ec','plromero@espol.edu.ec','achanaba@espol.edu.ec','lrodrigu@espol.edu.ec','mjimenez@espol.edu.ec','mpastuiz@espol.edu.ec','esanclem@espol.edu.ec','arivasfe@espol.edu.ec','pmpacton@espol.edu.ec','amoncayo@espol.edu.ec','jecaniza@espol.edu.ec','kfcaiced@espol.edu.ec','jaaviles@espol.edu.ec','jesamene@espol.edu.ec','lmoreira@espol.edu.ec','mafercal@espol.edu.ec','dagallar@espol.edu.ec','ecolmont@espol.edu.ec','aquinter@espol.edu.ec','pacampov@espol.edu.ec','mccastil@espol.edu.ec','bryjosal@espol.edu.ec','whurtare@espol.edu.ec','jcsolano@espol.edu.ec','marefrei@espol.edu.ec','rdurango@espol.edu.ec','cfalcone@espol.edu.ec','josecuev@espol.edu.ec','fearvaca@espol.edu.ec','vejaojed@espol.edu.ec','jmrodrig@espol.edu.ec','gandrade@espol.edu.ec','ajmarque@espol.edu.ec','jfaytong@espol.edu.ec','jwespino@espol.edu.ec','vrguadal@espol.edu.ec','gabanmur@espol.edu.ec','atoapant@espol.edu.ec','adortega@espol.edu.ec','jraizpru@espol.edu.ec','judagala@espol.edu.ec','farguell@espol.edu.ec','meromero@espol.edu.ec','slopez@espol.edu.ec','fveloz@espol.edu.ec','davaca@espol.edu.ec','dgnoboa@espol.edu.ec','rmacias@espol.edu.ec','aagarci@espol.edu.ec','asreyes@espol.edu.ec','gonvaca@espol.edu.ec','mongelo@espol.edu.ec','omartin@espol.edu.ec','gvilela@espol.edu.ec','sloaiza@espol.edu.ec','vosorio@espol.edu.ec','bperero@espol.edu.ec','cparedes@espol.edu.ec','jbermude@espol.edu.ec','jofersan@espol.edu.ec','ejgarcia@espol.edu.ec','jomabust@espol.edu.ec','monsalve@espol.edu.ec','enjimene@espol.edu.ec','gmcarvaj@espol.edu.ec','amtorres@espol.edu.ec','famoreir@espol.edu.ec','nadmflor@espol.edu.ec','caalronq@espol.edu.ec','lmarchan@espol.edu.ec','nvasquez@espol.edu.ec','nquijano@espol.edu.ec','jorollig@espol.edu.ec','pestolay@espol.edu.ec','jecordov@espol.edu.ec','jfmoncay@espol.edu.ec','jlasenci@espol.edu.ec','jjcordov@espol.edu.ec','purdiale@espol.edu.ec','noeelavi@espol.edu.ec','angdabaq@espol.edu.ec','josasanc@espol.edu.ec','mabrione@espol.edu.ec'];

const optionsRol = [
    { value: '1', label: 'ADMINISTRADOR' },
    { value: '2', label: 'ADMINISTRADOR DE UNIDAD' },
    { value: '3', label: 'ANALISTA DE GESTIÓN DE PROYECTOS'},
    { value: '4', label: 'DECANO'},
    { value: '5', label: 'DIRECTOR'},
    { value: '6', label: 'CONSULTOR'},
    { value: '7', label: 'DOCENTE INVESTIGADOR'},
    { value: '8', label: 'RESPONSABLE DE INGRESO DE PRODUCTOS'},
    { value: '9', label: 'ESPECIALISTA DE GESTIÓN DE PROYECTOS'},
    { value: '10', label: 'DELEGADO DE DECANATO DE INVESTIGACIÓN'},
    { value: '11', label: 'SEGUIMIENTO'},
    { value: '12', label: 'EDITOR ORCID'},
    { value: '13', label: 'TÉCNICO INVESTIGADOR'},
    { value: '14', label: 'ASISTENTE DE COORDINACIÓN'},
    { value: '15', label: 'ESPECIALISTA EN PROPUESTAS'},
  ];

export default class CatalogService{
    generateYearList(inicio:number, fin:number):number[]{
        const years: number[]=[];
        for(let year = inicio; year <= fin; year++){
            years.push(year);
        }
        return years;
    }

    getTipoColaborador():Array<ObjetoLabelFilter>{
        const decision: Array<ObjetoLabelFilter>=[];
        let interno:ObjetoLabelFilter={
            id:1,
            label:'Interno',
            visibilidad:''
        }
        decision.push(interno);
        let externo:ObjetoLabelFilter={
            id:2,
            label:'Externo',
            visibilidad:''
        }
        decision.push(externo);
        return decision;
    }

    getDecision():Array<ObjetoLabel>{
        const decision: Array<ObjetoLabel>=[];
        let si:ObjetoLabel={
            value:'S',
            label:'Sí'
        }
        decision.push(si);
        let no:ObjetoLabel={
            value:'N',
            label:'No'
        }
        decision.push(no);
        return decision;
    }

    getDecisionNum():Array<ObjetoLabelFilter>{
        const decision: Array<ObjetoLabelFilter>=[];
        let si:ObjetoLabelFilter={
            id:1,
            label:'Sí',
            visibilidad:''
        }
        decision.push(si);
        let no:ObjetoLabelFilter={
            id:0,
            label:'No',
            visibilidad:''
        }
        decision.push(no);
        return decision;
    }

    getEstadoEquipo():Array<ObjetoLabelFilter>{
        const decision: Array<ObjetoLabelFilter>=[];
        let op1:ObjetoLabelFilter={
            id: 1,
            label:'NUEVO',
            visibilidad:''
        }
        decision.push(op1);
        let op2:ObjetoLabelFilter={
            id: 2,
            label:'USADO',
            visibilidad:''
        }
        decision.push(op2);
        return decision;
    }

    getFrecuencia():Array<ObjetoLabelFilter>{
        const decision: Array<ObjetoLabelFilter>=[];
        let op1:ObjetoLabelFilter={
            id: 1,
            label:'FRECUENTE',
            visibilidad:''
        }
        decision.push(op1);
        let op2:ObjetoLabelFilter={
            id: 2,
            label:'ESPORADICO',
            visibilidad:''
        }
        decision.push(op2);
        return decision;
    }

    getCuartil():Array<ObjetoLabel>{
        const decision: Array<ObjetoLabel>=[];
        let sq:ObjetoLabel={
            value:'SQ',
            label:'SIN CUARTIL'
        }
        decision.push(sq);
        let q1:ObjetoLabel={
            value:'Q1',
            label:'C1/Q1'
        }
        decision.push(q1);
        let q2:ObjetoLabel={
            value:'Q2',
            label:'C2/Q2'
        }
        decision.push(q2);
        let q3:ObjetoLabel={
            value:'Q3',
            label:'C3/Q3'
        }
        decision.push(q3);
        let q4:ObjetoLabel={
            value:'Q4',
            label:'C4/Q4'
        }
        decision.push(q4);
        return decision;
    }

    getTipoSolicitud():Array<ObjetoLabel>{
        const decision: Array<ObjetoLabel>=[];
        let o0:ObjetoLabel={
            value:'A',
            label:'Modificación de Proyecto'
        }
        decision.push(o0);
        let o1:ObjetoLabel={
            value:'F',
            label:'Finalización de Proyecto'
        }
        decision.push(o1);
        let o2:ObjetoLabel={
            value:'P',
            label:'Agregar Colaboradores'
        }
        decision.push(o2);
        return decision;
    }

    getEstadoAoI():Array<ObjetoLabel>{
        const decision: Array<ObjetoLabel>=[];
        let o0:ObjetoLabel={
            value:'A',
            label:'Activo'
        }
        decision.push(o0);
        let o1:ObjetoLabel={
            value:'I',
            label:'Inactivo'
        }
        decision.push(o1);
        return decision;
    }

    getRolesUsuarioInvestigacion(){
        return optionsRol;
    }

    getRolColaboradorProducto():Array<ObjetoLabelFilter>{
        //S: siempre
        const decision: Array<ObjetoLabelFilter>=RolColaboradorProducto;      
        return decision;
    }

    getUsuariosProPBI():Array<string>{
        const pros: Array<string>=UsuarioPro;      
        return pros;
    }

    getMotivoProducto():Array<ObjetoLabel>{
        const decision: Array<ObjetoLabel>=[];
        const motivos: Array<MotivoDTO>= MotivoProducto();
        motivos.forEach(element => {
            let q4:ObjetoLabel={
                value: element.TipoMotivo,
                label: element.Texto
            }
            decision.push(q4);
        });      
        return decision;
    }
    
    GetMateriasItinerario():Array<Option>{
        let lista:Array<Option> = []
        let invest1={
            value: 'CCAG1003',
            label: 'INVESTIGACIÓN I',
        }
        lista.push(invest1)
        let invest2={
            value: 'CCAG1004',
            label: 'INVESTIGACIÓN II',
        }
        lista.push(invest2)
        return lista;
    }
    
    async obtenerCatalogoTipoProducto(): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetListaProductosEspActivos');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerCatalogoTipoProductoInactivo(): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetListaProductosEspInactivos');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerCatalogoCategoriaProducto(): Promise<ResponceApi<any>> {
        //CategoriaProductoDTO
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetListaCategoriasEspActivos');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerAllTipoProducto(): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetListaProductosEsperados');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetCatalogoById(id:number): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetCatalogoByIdCatagPadre/'+id);
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetCatalogoByCodigoStr(codigo: string): Promise<ResponceApi<any>> {
        const response1: AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack + APICATALOGO + '/GetCatalogoByCodigoStr/' + codigo);
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetCatalogoPaises(){
        // const response1:AxiosResponse<ResponceApi<any>> = await axios.get(localBack+APICATALOGO+'/GetPaises');
        // //console.log(response1.data); 
        // const listaTransformada = response1.data.listData.map((item) => {
        //     return {
        //       value: item.codigo,
        //       label: item.descripcion,
        //     };
        //   });       
        // return listaTransformada;
        const response1:AxiosResponse<ResponceApi<any>> = await axios.get(localBack+APICATALOGO+'/GetPaises');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetCatalogoByCatagPadre(cod:string): Promise<any> {
        const response1:AxiosResponse<any[]> = await axios.get(localBack+APICATALOGO+'/GetCatalogoByCatagPadre/'+cod);
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetCatalogoAreasImplementacion(): Promise<any>{
        const response1:AxiosResponse<ResponceApi<CatagNumberDTO>> = await axios.get(localBack+APICATALOGO+'/GetCatalogoByIdCatagPadre/'+3806);
        //console.log(response1.data); 
        // const listaTransformada = response1.data.listData.map((item) => {
        //     return {
        //       value: item.codigo,
        //       label: item.descripcion,
        //     };
        //   });       
        return response1.data;
    }

    async obtenerGetIndexCatalog(): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetIndexCatalog');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetMisProyectoEjecucion(id:number,token:any): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetMisProyectoEjecucion/'+id);
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetMisProyectosAprobados(id:number,token:any): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetMisProyectosAprobados/'+id);
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetMisProyectosAprobadosParticipo(id:number,token:any): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetMisProyectosAprobadosParticipo/'+id);
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerCatalogoUnidades(): Promise<any> {
        const response = await axios.get(localBack+'/api/Unidad');
        return response.data;
    }

    async obtenerGetAreasLineasInvestigacion(): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetAreasLineasInvestigacion');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetAreasConocimiento(): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetAreasConocimiento');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetSubAreasConocimiento(): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetSubAreasConocimiento');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetSubAreasConocimientoDet(): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetSubAreasConocimientoDet');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetSubAreas(codigo:number): Promise<ResponceApi<any>> {
        const response1:AxiosResponse<ResponceApi<any[]>> = await axios.get(localBack+APICATALOGO+'/GetSubAreas/'+codigo);
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetObjODS(): Promise<any> {
        const response1:AxiosResponse<any[]> = await axios.get(localBack+APICATALOGO+'/GetObjODS');
        //console.log(response1.data);        
        return response1.data;
    }

    async GetCategoriasTodas(): Promise<ResponceApi<Categoria>>{
        const response1:AxiosResponse<ResponceApi<Categoria>> = await axios.get(localBack+APICATALOGO+'/GetListaCategoriasEsp')
        return response1.data;
    }

    async GetCategoriasActivas(): Promise<ResponceApi<Categoria>>{
        const response1:AxiosResponse<ResponceApi<Categoria>> = await axios.get(localBack+APICATALOGO+'/GetListaCategoriasEspActivos');
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProductosEsperadosTodos(): Promise<ResponceApi<ProductoEsperado>> {
        const response1:AxiosResponse<ResponceApi<ProductoEsperado>> = await axios.get(localBack+APICATALOGO+'/GetListaProductosEsperados');
        //console.log(response1.data);        
        return response1.data;
    }

    async GetProductosEsperadosActivos(): Promise<ResponceApi<ProductoEsperado>> {
        const response1:AxiosResponse<ResponceApi<ProductoEsperado>> = await axios.get(localBack+APICATALOGO+'/GetListaProductosEspActivos');
        //console.log(response1.data);        
        return response1.data;
    }

    async GuardarCategoria(categoriaNew: GuardarCategoria,token:any):Promise<ResponceApi<GuardarCategoria>>{
        try {
              const response: AxiosResponse<ResponceApi<GuardarCategoria>> = await axios.post(
                localBack + APICATALOGO + '/PostCategoria',
              categoriaNew,
                {
                  headers: {
                      Authorization: `Bearer ${token}`,
                  },
                }
              );            
              if (response.data) {
                  return response.data;
              } else {
                  throw new Error('No se recibieron datos válidos.');
              }
            } catch (error) {
              console.error('Error al enviar la solicitud:', error);
              throw error; // Re-lanzar el error para que se maneje donde se llama a la función
            }
    }

    async GetCategoriaById(idCategoria: number, token: any): Promise<ResponceApi<GuardarCategoria>>{
        const response1:AxiosResponse<ResponceApi<GuardarCategoria>> = await axios.get(localBack+APICATALOGO+'/GetCategoriaById/'+idCategoria,
        {
            headers: {
              Authorization: `Bearer ${token}`
            }
        });
        return response1.data;
    }

    async ActualizarCategoriaById(token: any, idCategoria: number, categoria: GuardarCategoria): Promise<ResponceApi<GuardarCategoria>>{
        try {
          const response: AxiosResponse<ResponceApi<GuardarCategoria>> = await axios.put(
            localBack + APICATALOGO + '/UpdateCategoria/'+idCategoria,
            categoria,
            {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
            }
          );            
          if (response.data) {
              return response.data;
          } else {
              throw new Error('No se recibieron datos válidos.');
          }
        } catch (error) {
          console.error('Error al enviar la solicitud:', error);
          throw error; // Re-lanzar el error para que se maneje donde se llama a la función
        }
    }

    async obtenerGetAllRolInvestigador(): Promise<any> {
        const response1:AxiosResponse<any[]> = await axios.get(localBack+APICATALOGO+'/GetAllRolInvestigador');
        //console.log(response1.data);        
        return response1.data;
    }

    async obtenerGetRolInvestigador(): Promise<ResponceApi<IndexacionDTO>> {
        const response1:AxiosResponse<ResponceApi<IndexacionDTO>> = await axios.get(localBack+APICATALOGO+'/GetRolesInvestigacion');
        return response1.data;
    }

    async obtenerGetRolInvestigadorActivo(): Promise<ResponceApi<IndexacionDTO>> {
        const response1:AxiosResponse<ResponceApi<IndexacionDTO>> = await axios.get(localBack+APICATALOGO+'/GetRolesInvestigacionAct');
        return response1.data;
    }

    async GetRolInvestigadorActivo(): Promise<ResponceApi<IndexacionDTO>> {
        const response1:AxiosResponse<ResponceApi<IndexacionDTO>> = await axios.get(localBack+APICATALOGO+'/GetRolInvestigadorActivo');
        return response1.data;
    }
}
